var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getIcon,{tag:"component",staticClass:"v-svg-icon",style:({ width: _vm.size || _vm.tag, height: _vm.size || _vm.tag}),attrs:{"viewBox":_vm.computedViewBox},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }